import { useI18n } from "@/contexts/i18nContext";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback: FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const handleGoHome = () => {
    resetErrorBoundary();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full mx-auto p-6 bg-red-50 border border-red-400 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold text-red-800 mb-4">
          {t("toastMessageDescriptions.unknownError")}
        </h2>
        {error && (
          <pre className="text-red-700 bg-red-100 p-2 rounded overflow-x-auto">
            {error.message}
          </pre>
        )}
        <button
          onClick={handleGoHome}
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
        >
          {t("buttons.okay")}
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
